var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 5.69995C10.3636 5.69995 2.98818 11.0718 0 18.6545C2.98818 26.2372 10.3636 31.609 19 31.609C27.6364 31.609 35.0118 26.2372 38 18.6545C35.0118 11.0718 27.6364 5.69995 19 5.69995ZM19 27.2909C14.2327 27.2909 10.3636 23.4218 10.3636 18.6545C10.3636 13.8872 14.2327 10.0181 19 10.0181C23.7673 10.0181 27.6364 13.8872 27.6364 18.6545C27.6364 23.4218 23.7673 27.2909 19 27.2909ZM19 13.4727C16.1327 13.4727 13.8182 15.7872 13.8182 18.6545C13.8182 21.5218 16.1327 23.8363 19 23.8363C21.8673 23.8363 24.1818 21.5218 24.1818 18.6545C24.1818 15.7872 21.8673 13.4727 19 13.4727Z","fill":"#6975BD"}));
}

Eye.defaultProps = {"viewBox":"0 0 38 38","fill":"none"};

module.exports = Eye;

Eye.default = Eye;
